// src/config/wagmi.ts
import { cookieStorage, createStorage } from "@wagmi/core";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { soneium } from "@reown/appkit/networks";

// reemplazar projectId por el de reown
export const projectId = import.meta.env.VITE_PROJECT_ID;

if (!projectId) {
  console.warn("VITE_PROJECT_ID is not defined - wallet connect will not work");
}

// red soportada
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const networks = [soneium] as const;

// Wagmi adapter
export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    key: "harkan-boxes-wallet",
    storage: cookieStorage,
  }),
  ssr: false,
  projectId: projectId || "",
  networks: [...networks],
});

export const config = wagmiAdapter.wagmiConfig;

export { soneium };
